export default "__VITE_ASSET__CWAAy3dO__"